// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6268":"821280b7","6647":"821280b7","8275":"acaf7150"}[chunkId] + ".chunk.css";
};